import { Link } from 'react-router-dom'
import { LogoSvg } from '@/assets/brand/logos'

/**
 * Client-side 404.
 *
 * Direct hits on an unknown URL never reach this component - Vercel serves
 * public/404.html with a real 404 status before the app loads. This covers
 * in-app navigation to a path that does not exist, which used to redirect
 * silently to the homepage and leave the visitor wondering what happened.
 */
export function NotFound() {
  const links = [
    { to: '/', label: 'Home', description: "what Inkwell Jr. is and who it's for" },
    { to: '/how-it-works', label: 'How it works', description: 'the lessons and the writing loop' },
    { to: '/request-access', label: 'Request access', description: 'ask for a beta invitation' },
    { to: '/login', label: 'Sign in', description: 'for families who already have an account' },
  ]

  return (
    <div className="min-h-screen bg-[var(--color-kids-bg)]">
      <header className="bg-white/95 border-b border-[var(--color-kids-border)]">
        <div className="container mx-auto pl-7 pr-6 h-[76px] flex items-center">
          <Link to="/" className="flex items-center">
            <img src={LogoSvg} alt="Inkwell Jr." className="h-[44px] md:h-[52px]" />
          </Link>
        </div>
      </header>

      <main className="container mx-auto px-6 py-16 max-w-2xl">
        <p className="text-xs font-medium uppercase tracking-wider text-[var(--color-kids-text-muted)] mb-2">
          Error 404
        </p>
        <h1 className="font-display text-3xl md:text-4xl font-bold text-[var(--color-kids-text)] mb-3">
          That page doesn&apos;t exist
        </h1>
        <p className="text-[var(--color-kids-text-muted)] mb-8 leading-relaxed">
          The address you asked for isn&apos;t a page here. It may have been a typo,
          or a link that has since moved. The writing studio needs a signed-in
          account, so a page you remember may simply be behind the login.
        </p>

        <ul className="space-y-3">
          {links.map((link) => (
            <li key={link.to}>
              <Link
                to={link.to}
                className="font-semibold text-[var(--color-kids-primary)] hover:underline"
              >
                {link.label}
              </Link>
              <span className="text-[var(--color-kids-text-muted)]"> — {link.description}</span>
            </li>
          ))}
        </ul>

        <p className="mt-10 text-sm text-[var(--color-kids-text-muted)]">
          Still stuck? Email{' '}
          <a
            href="mailto:support@inkwelljr.com"
            className="text-[var(--color-kids-primary)] hover:underline"
          >
            support@inkwelljr.com
          </a>
          .
        </p>
      </main>
    </div>
  )
}
